import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserObj } from '../../../classes/user-obj';

@Component({
  selector: 'lib-delete-user-warning',
  templateUrl: './delete-user-warning.component.html',
  styleUrls: ['./delete-user-warning.component.scss']
})
export class DeleteUserWarningComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: UserObj
  ) { }

  ngOnInit() {
  }

}
